import React from "react";
import PropTypes from "prop-types";

import TagStreamWrapper from "stream/containers/TagStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";

export default function TagStream(props) {
  return (
    <TagStreamWrapper slug={props.match.params.tag}>
      {({ streamParams }) => (
        <Stream {...streamParams} contentComponent={FullStoryCard} />
      )}
    </TagStreamWrapper>
  );
}

TagStream.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      tag: PropTypes.string.isRequired,
    }),
  }),
};
